module.exports = __webpack_public_path__ + "static/media/airline@1080.07dfbbc2.jpg";